import { post } from '../request'

//高危报警报表
export const highRiskAlarm = params => {
    return post('/statistics/highRiskAlarm', params)
}